// extracted by mini-css-extract-plugin
export var brandOverlay = "hotel-brand-card-module--brandOverlay--9b9ae";
export var hotelBrandCard = "hotel-brand-card-module--hotelBrandCard--42ebf";
export var hotelBrandCardLink = "hotel-brand-card-module--hotelBrandCardLink--907c3";